import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

import Dialog from '@techsoftware/happay-widgets/DialogBox';
import Button from '@techsoftware/happay-widgets/Button';
import DataSource from './data';
import DocSection from './docSection';

const GuideLinesDialog = props => {
  let Data = [...DataSource];

  const jumpToSection = id => e => {
    document.getElementById(id).scrollIntoView(true);
  };

  const {
    userInfo = { channel: 'HS-SBM' },
    closeGuideLinesDialog = () => {},
  } = props;

  if (userInfo.channel.includes('SBM')) {
    Data = Data.filter(item => item.heading === 'PAN Card');
  }

  return (
    <Dialog
      open
      title={<div className="margin-l-80">Documents & Upload Guidelines</div>}
      titleBorder
      fullWidth
      fullHeight
      crossIcon
      onClose={closeGuideLinesDialog}
    >
      <div className="margin-t-30 margin-l-100">
        {Data.length > 1 &&
          Data.map(item => (
            <Button
              text={item.heading}
              variant="secondary"
              size="small"
              className="hw-chips margin-r-20  black-color"
              onClick={jumpToSection(item.heading)}
            />
          ))}
        {Data.length > 0 && Data.map(item => <DocSection docData={item} />)}
        <div className="endOfDoc margin-tb-50"> End of document</div>
      </div>
    </Dialog>
  );
};

GuideLinesDialog.propTypes = {
  userInfo: PropTypes.object,
  closeGuideLinesDialog: PropTypes.func,
};

export default GuideLinesDialog;
